(()=>{
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 function initialize(scope=document){
  scope.querySelectorAll('[data-product-gallery], [data-write-gallery]').forEach(gallery=>{
   if(gallery.dataset.ready)return;gallery.dataset.ready='true';
   const track=gallery.querySelector('[data-gallery-track]'),thumbs=[...gallery.querySelectorAll('[data-gallery-index]')],status=gallery.querySelector('[data-gallery-status]');
   let index=0,raf;
   function update(){
    index=Math.max(0,Math.min(thumbs.length-1,Math.round(track.scrollLeft/track.clientWidth)));
    thumbs.forEach((button,i)=>button.setAttribute('aria-current',String(i===index)));
    const label=`${index+1} / ${thumbs.length}`;if(status.textContent!==label)status.textContent=label;
   }
   function go(next){index=(next+thumbs.length)%thumbs.length;track.scrollTo({left:index*track.clientWidth,behavior:reduced.matches?'instant':'smooth'});}
   gallery.querySelector('[data-gallery-prev]').addEventListener('click',()=>go(index-1));
   gallery.querySelector('[data-gallery-next]').addEventListener('click',()=>go(index+1));
   thumbs.forEach((button,i)=>button.addEventListener('click',()=>go(i)));
   track.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(update);},{passive:true});
   track.addEventListener('keydown',event=>{
    if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
    event.preventDefault();go(event.key==='Home'?0:event.key==='End'?thumbs.length-1:index+(event.key==='ArrowRight'?1:-1));
   });
   new ResizeObserver(()=>track.scrollTo({left:index*track.clientWidth,behavior:'instant'})).observe(track);
   update();
  });
 }
 initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
